import confetti from "canvas-confetti"

const BRAND_COLORS = ["#1F6FEB", "#0FB8A0", "#22A06B", "#E8A23D"]
let lastFiredAt = 0

// A one-shot celebration burst, debounced so two near-simultaneous triggers
// (e.g. Review hitting its end and the feed reaching inbox zero) fire once.
export function celebrate() {
  const now = performance.now()
  if (now - lastFiredAt < 1000) return
  lastFiredAt = now

  const defaults = { origin: { y: 0.7 }, zIndex: 200, colors: BRAND_COLORS, disableForReducedMotion: true }
  confetti({ ...defaults, particleCount: 90, spread: 72, startVelocity: 46 })
  confetti({ ...defaults, particleCount: 55, spread: 110, decay: 0.92, scalar: 1.2 })
}
